// utils/showWhenNotNil.js
import isNil from "lodash/isNil";

/**
 * Only render when `value` is non‐nil and (by default) non‐empty-string.
 *
 * @param {*} value – the thing you’re checking
 * @param {*} [content=value] – what to render when `value` passes checks
 * @param {Object} [options]
 * @param {boolean} [options.allowEmptyString=false] – if true, skip the empty‐string check
 * @returns {*} content or null
 */
export const showWhenNotNil = (
  value,
  content = value,
  { allowEmptyString = false } = {}
) => {
  // always hide null or undefined
  if (isNil(value)) {
    return null;
  }

  // by default hide `""` or all‐whitespace strings
  if (!allowEmptyString && typeof value === "string" && value.trim() === "") {
    return null;
  }

  return content;
};
